(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('DeleteAccountController', DeleteAccountController);

    DeleteAccountController.$inject = ['Auth', 'Principal'];

    function DeleteAccountController (Auth, Principal) {
        var vm = this;
		
		vm.deleteAccount = deleteAccount;
		vm.logout = logout;

        function deleteAccount() {
      
			Principal.identity(true).then(function(account) {
				Auth.deleteAccount(account).then(function() {
					vm.error = null;
					vm.success = 'OK';
					vm.logout();
				}).catch(function() {
					vm.success = null;
					vm.error = 'ERROR';
				});
			});
        }
		
		function logout() {
            Auth.logout();
            $state.go('home');
        }
    }
})();
